import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrimeNgModule} from './prime-ng/prime-ng.module';
import {InfoDialogComponent} from './components/info-dialog/info-dialog.component';
import {ConsultaUsuarioComponent} from './components/registro-persona/consulta-usuario.component';
import {LoaderComponent} from './components/loader/loader.component';
import {ReactiveFormsModule} from "@angular/forms";
import {KeyFilterModule} from "primeng/keyfilter";
import {FileUtilsService} from "./services/file-utils-service";
import {InputGroupModule} from "primeng/inputgroup";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {
    UsuarioDialogComponent
} from "../users/mnto-usuarios/components/usuarios/usuario-dialog/usuario-dialog.component";

@NgModule({
    declarations: [
        InfoDialogComponent,
        ConsultaUsuarioComponent,
        LoaderComponent,
    ],
    imports: [
        CommonModule,
        PrimeNgModule,
        ReactiveFormsModule,
        KeyFilterModule,
        InputGroupModule,
        InputGroupAddonModule,
        UsuarioDialogComponent
    ],
    exports: [
        InfoDialogComponent,
        ConsultaUsuarioComponent,
        LoaderComponent
    ],
    providers: [ConsultaUsuarioComponent, FileUtilsService]
})
export class SharedModule {
}
